package com.htmlagent.site.i18n

// Generated from i18n/strings.json. Do not edit: edit the JSON and rebuild.

/** The texts of the gate area. */
interface GateStrings {
    val tagline: String

    val emailLabel: String

    val emailPlaceholder: String

    val submit: String

    val guestLimitTitle: String

    val guestLimitLead: String

    val guestSubmit: String

    val invalidEmail: String

    val notALoginNotice: String

    val shortNotice: String

    val why: String

    val sending: String

    val linkSentTitle: String

    val linkSentLead: String

    val linkSentExpiry: String

    val matchLead: String

    val waiting: String

    val otherEmail: String

    val approveTitle: String

    val approveLead: String

    val approveWarning: String

    fun approveChoice(number: Int): String

    val approveCancel: String

    val approvedTitle: String

    val approvedBody: String
}

/** The gate area in Spanish. */
internal object SpanishGateStrings : GateStrings {
    override val tagline: String = "Pide una web. Mírala nacer."

    override val emailLabel: String = "Tu correo"

    override val emailPlaceholder: String = "nombre@dominio.com"

    override val submit: String = "Enviarme el enlace"

    override val guestLimitTitle: String = "Sigue con tu correo"

    override val guestLimitLead: String = "Has usado todas las peticiones de invitado. Déjanos tu correo y te enviamos un enlace: al abrirlo aquí sigues sin límite y tus páginas vienen contigo."

    override val guestSubmit: String = "Empezar sin correo"

    override val invalidEmail: String = "Escribe un correo con la forma nombre@dominio."

    override val notALoginNotice: String = "El enlace demuestra que el correo es tuyo, así que nadie más puede ver tus páginas. Caduca en 15 minutos y solo sirve una vez. Si se abre en otro navegador, eliges allí el número que ves aquí y entras aquí."

    override val shortNotice: String = "Sin contraseña: te enviamos un enlace para entrar."

    override val why: String = "¿Por qué?"

    override val sending: String = "Enviando…"

    override val linkSentTitle: String = "Revisa tu correo"

    override val linkSentLead: String = "Abre el enlace que te enviamos a"

    override val linkSentExpiry: String = "Caduca en 15 minutos."

    override val matchLead: String = "¿Se abre en otro navegador? Elige allí este número:"

    override val waiting: String = "Esperando… entrarás aquí solo"

    override val otherEmail: String = "Usar otro correo"

    override val approveTitle: String = "¿Qué número ves en la otra ventana?"

    override val approveLead: String = "La ventana donde pediste el enlace entrará como"

    override val approveWarning: String = "¿No ves ninguna ventana esperando con un número? Entonces no lo pediste tú: cierra esta página."

    override fun approveChoice(number: Int): String = "Elegir el $number"

    override val approveCancel: String = "No lo he pedido yo"

    override val approvedTitle: String = "Listo, la otra ventana ya entró"

    override val approvedBody: String = "Vuelve a ella para seguir. Esta ya puedes cerrarla."
}

/** The gate area in English. */
internal object EnglishGateStrings : GateStrings {
    override val tagline: String = "Ask for a site. Watch it build."

    override val emailLabel: String = "Your email"

    override val emailPlaceholder: String = "name@domain.com"

    override val submit: String = "Email me a link"

    override val guestLimitTitle: String = "Go on with your email"

    override val guestLimitLead: String = "You have used every guest request. Leave your email and we will send you a link: open it here to go on without a limit, with your pages."

    override val guestSubmit: String = "Start without an email"

    override val invalidEmail: String = "Enter an email shaped like name@domain."

    override val notALoginNotice: String = "The link proves the email is yours, so nobody else can see your pages. It expires in 15 minutes and works only once. If it opens in another browser, you pick there the number you see here, and you are in here."

    override val shortNotice: String = "No password: we email you a link to sign in."

    override val why: String = "Why?"

    override val sending: String = "Sending…"

    override val linkSentTitle: String = "Check your email"

    override val linkSentLead: String = "Open the link we sent to"

    override val linkSentExpiry: String = "It expires in 15 minutes."

    override val matchLead: String = "Opens in another browser? Pick this number there:"

    override val waiting: String = "Waiting… you will be signed in here"

    override val otherEmail: String = "Use another email"

    override val approveTitle: String = "Which number does the other window show?"

    override val approveLead: String = "The window where you asked for the link will sign in as"

    override val approveWarning: String = "No window waiting with a number? Then you did not ask for it: close this page."

    override fun approveChoice(number: Int): String = "Pick $number"

    override val approveCancel: String = "I did not ask for it"

    override val approvedTitle: String = "Done, the other window is in"

    override val approvedBody: String = "Go back to it to carry on. You can close this one."
}
